document.addEventListener("DOMContentLoaded", function () {
  // Alle Abfragen von HTML-Elementen MÜSSEN innerhalb dieser Funktion stehen.
  const button = document.getElementById("pr_button");
  const widthInput = document.getElementById("pr_width");
  const heightInput = document.getElementById("pr_height");
  const resultDiv = document.getElementById("pr_result");

  // Sicherheitsprüfung: Nur ausführen, wenn die Elemente gefunden wurden
  if (!button || !widthInput || !heightInput || !resultDiv) {
    console.warn("Preisrechner Elemente nicht gefunden. Funktion wird abgebrochen.");
    return;
  }

  button.addEventListener("click", function () {
    const width = parseFloat(widthInput.value);
    const height = parseFloat(heightInput.value);

    if (!width || !height) {
      resultDiv.innerText = "Zu schnell. Ein Maß fehlt noch! 🙂";
      return;
    }

    const area = width * height;

    // Preisformel
    const minPrice = 400;
    const baseArea = 60 * 40; 
    const refArea = 160 * 100; 
    const refPrice = 1000;

    const factor = (refPrice - minPrice) / (refArea - baseArea);

    let price = area <= baseArea ? minPrice : minPrice + (area - baseArea) * factor;
    price = Math.round(price);

    let maxPrice = Math.round(price * 1.2);

    // Format-Hinweise (kurz & dezent)
    function getFormatHint(w, h) {
      const ratio = w / h;

      if (ratio > 0.9 && ratio < 1.1) {
        return "Ruhiges, ausgeglichenes Format – schön für Auftragsarbeiten.";
      }

      if (ratio >= 1.7) {
        return "Leichtes Panoramaformat – eignet sich wunderbar für horizontale Motive.";
      }

      if (ratio <= 0.65) {
        return "Elegantes Hochformat – sehr passend für klare, vertikale Motive.";
      }

      return "Zeitloses Rechteckformat – vielseitig für unterschiedliche Auftragsmotive.";
    }

    const hint = getFormatHint(width, height);

    // Ausgabe minimalistisch
    resultDiv.innerHTML =
      `<strong>Preis: ${price} €</strong><br>` +
      `Maximal (bei höherem Aufwand): ca. ${maxPrice} €<br><br>` +
      `<span style="font-size:0.85em; color:#444;"><strong>Hinweis:</strong> ${hint}</span>`;
  });
});